// Panel side of the in-app messages (user notices). Super administrator only.

const headers = () => ({
    'Content-Type': 'application/json; charset=UTF-8',
    'Authorization': sessionStorage.getItem('agronetToken'),
    'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
});

// Resolves to {ok, status, data} or {ok: false, status, message}; never rejects.
export const noticesRequest = (method, path, body) =>
    fetch(`${process.env.REACT_APP_API_URL}/panel/user_notices${path}`, {
        method,
        headers: headers(),
        body: body ? JSON.stringify(body) : undefined
    })
        .then(res =>
            res.text().then(text => {
                let data = null;
                try {
                    data = text ? JSON.parse(text) : null;
                } catch (e) {
                    data = null;
                }
                if (res.ok) {
                    return {ok: true, status: res.status, data};
                }
                return {
                    ok: false,
                    status: res.status,
                    message: (data && data.message) || `Error: ${res.status} ${res.statusText}`
                };
            })
        )
        .catch(err => ({ok: false, status: 0, message: err.message}));

export const clearUserNoticeStatus = () => ({type: 'USER_NOTICES_CLEAR_STATUS'});

export const getUserNoticeBatches = () => dispatch => {
    dispatch({type: 'USER_NOTICES_BATCHES_PENDING'});
    return noticesRequest('GET', '/batches').then(res =>
        res.ok
            ? dispatch({type: 'USER_NOTICES_BATCHES_SUCCESS', batches: res.data})
            : dispatch({type: 'USER_NOTICES_BATCHES_ERROR', error: res.message})
    );
};

export const getUserNotices = (userId, activeOnly) => dispatch => {
    dispatch({type: 'USER_NOTICES_LIST_PENDING'});
    return noticesRequest('GET', `?userId=${encodeURIComponent(userId)}&activeOnly=${activeOnly}`).then(res =>
        res.ok
            ? dispatch({type: 'USER_NOTICES_LIST_SUCCESS', notices: res.data})
            : dispatch({type: 'USER_NOTICES_LIST_ERROR', error: res.message})
    );
};

export const clearUserNotices = () => ({type: 'USER_NOTICES_LIST_CLEAR'});

export const searchNoticeUsers = query => dispatch => {
    if (!query || query.trim().length < 2) {
        return dispatch({type: 'USER_NOTICES_USERS_SUCCESS', users: []});
    }
    return noticesRequest('GET', `/users?query=${encodeURIComponent(query.trim())}`).then(res =>
        res.ok
            ? dispatch({type: 'USER_NOTICES_USERS_SUCCESS', users: res.data})
            : dispatch({type: 'USER_NOTICES_USERS_ERROR', error: res.message})
    );
};

// Single user: POST /panel/user_notices. Several users or everyone: POST /bulk.
export const sendUserNotice = ({single, body}) => dispatch => {
    dispatch({type: 'USER_NOTICES_SEND_PENDING'});
    return noticesRequest('POST', single ? '' : '/bulk', body).then(res =>
        res.ok
            ? dispatch({type: 'USER_NOTICES_SEND_SUCCESS', result: res.data, single})
            : dispatch({type: 'USER_NOTICES_SEND_ERROR', error: res.message})
    );
};

// Counts the audience without creating anything.
export const previewUserNoticeAudience = body => dispatch => {
    dispatch({type: 'USER_NOTICES_PREVIEW_PENDING'});
    return noticesRequest('POST', '/bulk', {...body, dryRun: true}).then(res =>
        res.ok
            ? dispatch({type: 'USER_NOTICES_PREVIEW_SUCCESS', preview: res.data})
            : dispatch({type: 'USER_NOTICES_PREVIEW_ERROR', error: res.message})
    );
};

// action: 'deactivate' | 'activate' | 'block_now'
export const changeUserNotice = (id, action) => dispatch => {
    dispatch({type: 'USER_NOTICES_CHANGE_PENDING'});
    return noticesRequest('POST', `/${id}/${action}`).then(res =>
        res.ok
            ? dispatch({type: 'USER_NOTICES_CHANGE_SUCCESS', notice: res.data})
            : dispatch({type: 'USER_NOTICES_CHANGE_ERROR', error: res.message})
    );
};

export const stopUserNoticeBatch = batchId => dispatch => {
    dispatch({type: 'USER_NOTICES_CHANGE_PENDING'});
    return noticesRequest('POST', `/batches/${encodeURIComponent(batchId)}/deactivate`).then(res => {
        if (res.ok) {
            dispatch({type: 'USER_NOTICES_STOP_BATCH_SUCCESS', batchId, deactivated: res.data.deactivated});
            return dispatch(getUserNoticeBatches());
        }
        return dispatch({type: 'USER_NOTICES_CHANGE_ERROR', error: res.message});
    });
};

export const getUserNoticeEvents = (id, page) => dispatch => {
    dispatch({type: 'USER_NOTICES_EVENTS_PENDING', page});
    return noticesRequest('GET', `/${id}/events?page=${page}&size=20`).then(res =>
        res.ok
            ? dispatch({type: 'USER_NOTICES_EVENTS_SUCCESS', events: res.data, page})
            : dispatch({type: 'USER_NOTICES_EVENTS_ERROR', error: res.message})
    );
};
